/**
 * Internal dependencies
 */
import vd from 'lib/vd';
import * as actions from 'state/action-types';
import { createAction } from 'state/utils';

// this is actually last succesfully ran operation
export default () => (dispatch) => {
	return vd
		.importOperation()
		.getMostRecentCompleted()
		.then((operation) => {
			dispatch(createAction(actions.SET_OPERATION_LAST_RAN, { operation }));
			return operation;
		})
		.catch((error) => {
			if (error === 'Error: Not Found') {
				return null;
			}
			throw error;
		});
};
